import type { AncestorGraph } from '../domain/AncestorGraph';
import type { MigrationArc } from '../domain/MigrationArc';
import type { DotCell } from '../domain/DotCell';
import type { FailedPlace } from '../domain/FailedPlace';
import type { LineagePath } from '../domain/LineagePath';
import type { GeocodeProgress } from '../domain/GeocodeProgress';
import { Observable } from '../utils/Observable';

export interface AppState {
  graph: AncestorGraph | null;
  arcs: MigrationArc[];
  dotMap: Map<string, DotCell>;
  branchAssignments: Map<string, string>; // personId → branchId
  branchPaths: LineagePath[];
  geocodeFailures: FailedPlace[]; // places that failed geocoding, with the events using each
  geocodeUnverified: FailedPlace[]; // resolved places that name no region — "places to check"
  geocodeProgress: GeocodeProgress;
}

// setState replaces state references — never mutate dotMap or branchAssignments
// in place; always pass a new Map instance so subscribers are notified correctly.
// After geocodeLocations() resolves in P-11+, also pass a new arcs array so
// ArcLayer/DotLayer subscribers are notified that coordinates are now populated.
const INITIAL_APP_STATE: AppState = {
  graph: null,
  arcs: [],
  dotMap: new Map(),
  branchAssignments: new Map(),
  branchPaths: [],
  geocodeFailures: [],
  geocodeUnverified: [],
  geocodeProgress: {
    resolved: 0,
    total: 0,
    failed: 0,
    deferred: 0,
    cacheHits: 0,
    rateLimitHit: false,
  },
};

export const AppStore = new Observable<AppState>(INITIAL_APP_STATE);
